module.exports = __webpack_public_path__ + "img/user-alt.c56e1732.svg";